export default __webpack_public_path__ + "static/media/myBook.ba2dbe57.png";